import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import {
  successAlert,
  addLoading,
  removeLoading,
  fetchStaticText,
} from './../../ui/src/actions.js';
import {
  fetchHomeTraffic,
  fetchInfomixArticles,
  getHomeArticleFromKosiceonline,
  getHomeArticleFromTvKosice,
} from './../actions';
import { OnAirPlaylist } from './../component/onAirPlaylist';
import { ImageSlider } from './../component/imageSlider';
import { Icon } from './../../ui/src/component/icon/';
import { StandardArticle } from './../../ui/src/component/article';
import { StandardArticleCustom } from './../component/standardArticleCustom';
import { CsmArticleLink } from './../../ui/src/component/csmArticlelink';
import Api from './../../ui/src/api';
import { dataBaseUrl, nl2p, getProp } from './../../ui/src/utilities';
import { imageBaseUrl, imageResizeBaseUrl } from './../../ui/src/utilities.js';
import { Traffic } from './../component/traffic';
import Banner from '../component/banner';
import { WeatherWidget } from './../component/weatherWidget';
import { CalendarWidget } from './../component/calendarWidget';
import ArticleTiles from '../component/articleTiles';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      playlist: [],
    };
  }

  componentDidMount() {
    Home.init(this.props.dispatch);
    this.props.dispatch(getHomeArticleFromTvKosice());
    this.props.dispatch(getHomeArticleFromKosiceonline());

    this.fetchPlaylist();
    this.playlistInterval = setInterval(() => {
      this.fetchPlaylist();
    }, 30000);
  }

  componentWillUnmount() {
    clearInterval(this.playlistInterval);
  }

  fetchPlaylist() {
    this.props.dispatch(addLoading());
    return Api.get(`/playlists/${process.env.REACT_APP_CONTENT_SPACE}?limit=5`)
      .then(response => {
        this.setState({ playlist: response.items });
        this.props.dispatch(removeLoading());
      })
      .catch(error => {
        console.error(`Failed to fetch playlist: ${error}`);
        this.props.dispatch(removeLoading());
      });
  }

  onClickBtn() {
    this.props.dispatch(successAlert('Podarilo sa!'));
  }

  render() {
    let firstArticle = null;
    let firstArticlePicture = null;
    let firstArticlePerex = null;
    if (getProp(this.props, 'infomixArticles', []).length > 0) {
      firstArticle = this.props.infomixArticles[0];
      firstArticlePicture = getProp(firstArticle, 'picture.uri', null);
      firstArticlePerex = getProp(firstArticle, 'perex2');
      if (!firstArticlePerex) {
        firstArticlePerex = getProp(firstArticle, 'perex');
      }
      firstArticlePerex = nl2p(firstArticlePerex);
      if (firstArticlePicture !== null) {
        firstArticlePicture = `${imageResizeBaseUrl(
          1000,
        )}/${firstArticlePicture}`;
      } else {
        firstArticlePicture =
          'https://s-media-cache-ak0.pinimg.com/originals/e7/be/07/e7be07184a41854330bbaa1b5433e3cd.jpg';
      }
    }

    const trafficItems = this.props.trafficIds
      .filter(id => {
        return id in this.props.trafficEntities;
      })
      .map(id => {
        return this.props.trafficEntities[id];
      });

    return (
      <div>
        <div className="bg-alt-light section">
          <div className="container">
            <div className="row on-air-container">
              <div className="col-sm-12 col-md-9 col-lg-9">
                <ImageSlider
                  images={getProp(this.props, 'banners.widgets', [])
                    .filter(item => {
                      return item.type === 'imagead';
                    })
                    .map(item => {
                      return {
                        image: `${dataBaseUrl()}/${item.uri}`,
                        label: getProp(item, 'description', ''),
                        url: getProp(item, 'target', null),
                      };
                    })}
                />
              </div>
              <div className="col-sm-12 col-md-3 col-lg-3">
                <OnAirPlaylist items={this.state.playlist} />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="container">
            <Banner id="banner-radiokosice-sk-pred-dopravnym-servisom" />
          </div>
        </div>
        <div className="container">
          <Traffic items={trafficItems} />

          <Link to="/infomix">
            <h1>
              Infomix <Icon name="chevron-circle-right" className="icon-md" />
            </h1>
          </Link>
          <div className="articles">
            {firstArticle !== null ? (
              <div className="bg-alt-light big-article-container">
                <section className="row">
                  <div className="col-md-6">
                    <CsmArticleLink article={firstArticle}>
                      <div
                        className="big-article-image"
                        style={{
                          backgroundImage: `url(${firstArticlePicture})`,
                        }}
                      />
                    </CsmArticleLink>
                  </div>
                  <div className="col-md-6 big-article">
                    <h3 className="font-bold">
                      <CsmArticleLink article={firstArticle}>
                        {firstArticle.name}
                      </CsmArticleLink>
                    </h3>
                    <div
                      dangerouslySetInnerHTML={{ __html: firstArticlePerex }}
                    />
                  </div>
                </section>
                <CsmArticleLink article={firstArticle} className="link-more">
                  Viac <Icon name="chevron-circle-right" />
                </CsmArticleLink>
              </div>
            ) : null}
            <div className="row">
              {this.props.infomixArticles &&
                this.props.infomixArticles.slice(1).map(item => {
                  return (
                    <div key={item._id} className="col-sm-6 col-md-3">
                      <StandardArticle article={item} />
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        <div>
          <div className="container">
            <Banner id="banner-radiokosice-sk-za-infomixom" />
          </div>
        </div>

        <div
          className="container-fluid bg-alt-light"
          style={{ marginBottom: '30px' }}
        >
          <div className="row">
            <div className="widget-area">
              <div className="container">
                <div className="row">
                  <div className="col-md-6 widget-left">
                    <WeatherWidget />
                  </div>
                  <div className="col-md-6 widget-right widget-darker">
                    <CalendarWidget />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          {this.props.homeKosiceonlineArticles && (
            <div>
              <a href="https://www.kosiceonline.sk" target="_blank" rel="noopener noreferrer">
                <h2 className="h1">
                  Košice Online{' '}
                  <Icon name="chevron-circle-right" className="icon-md" />
                </h2>
              </a>
              <div class="articles">
                <ArticleTiles
                  articles={(this.props.homeKosiceonlineArticles || []).map(
                    item => (
                      <StandardArticleCustom
                        pictureSize={990}
                        article={item}
                        author={'Košice Online'}
                        baseUrl="http://www.kosiceonline.sk"
                      />
                    ),
                  )}
                />
              </div>
            </div>
          )}

          {this.props.homeTvKosiceArticles && (
            <div className="tv-kosice">
              <a href="https://www.tvkosice.sk" target="_blank" rel="noopener noreferrer">
                <h2 className="h1">
                  TV Košice{' '}
                  <Icon name="chevron-circle-right" className="icon-md" />
                </h2>
              </a>
              <div class="articles">
                <ArticleTiles
                  articles={this.props.homeTvKosiceArticles.map(item => (
                    <StandardArticleCustom
                      pictureSize={990}
                      article={item}
                      imgOverride={
                        imageBaseUrl(800) + '/' + getProp(item, 'picture.uri')
                      }
                      author={'Televízia Košice'}
                      baseUrl="https://www.tvkosice.sk"
                    />
                  ))}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  dispatch: PropTypes.func.isRequired,
  trafficIds: PropTypes.array.isRequired,
  trafficEntities: PropTypes.object.isRequired,
  infomixArticles: PropTypes.array,
  banners: PropTypes.object,
  homeKosiceonlineArticles: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.number,
      name: PropTypes.string,
      date: PropTypes.string,
      picture: PropTypes.shape({
        uri: PropTypes.string,
      }),
      section: PropTypes.shape({
        name: PropTypes.string,
      }),
      url: PropTypes.string,
    }),
  ),
  homeTvKosiceArticles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      date: PropTypes.string,
      created: PropTypes.string,
      picture: PropTypes.shape({
        uri: PropTypes.string,
      }),
      section: PropTypes.shape({
        name: PropTypes.string,
      }),
      url: PropTypes.string,
    }),
  ),
};

Home.defaultProps = {
  infomixArticles: [],
};

Home.init = dispatch => {
  return Promise.all([
    dispatch(fetchHomeTraffic()),
    dispatch(fetchInfomixArticles()),
    dispatch(
      fetchStaticText(
        process.env.REACT_APP_CONTENT_SPACE,
        'BANNERS',
        'radio-kosice-homepage-banners',
      ),
    ),
  ]);
};

Home.fetchData = ({ store }) => {
  return Home.init(store.dispatch);
};

const mapStateToProps = state => {
  return {
    trafficEntities: state.trafficEntities.byId,
    trafficIds: state.homeTraffic.items,
    infomixArticles: state.infomixArticles.data.articles,
    banners: state.banners.data.content,
    homeKosiceonlineArticles: state.homeKosiceonlineArticle.data,
    homeTvKosiceArticles: state.homeTvKosiceArticle.data,
  };
};

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/app/container/home.js